import { useQueryApi } from 'utils/api'

const API_KS_PATH = `${
  process.env.NEXT_PUBLIC_BCKS_USE_AMBASSADOR === 'true' ? '/guru' : ''
}/guru-ks`

export interface ResponsePhicosUploadPhoto {
  token: string
}

export const useAPIPhicosGetTokenUploadPhoto = () =>
  useQueryApi<ResponsePhicosUploadPhoto>(
    `${API_KS_PATH}/v1/ks/substance-cbt-assessment/jwt/upload-photo`,
    {
      queryConfig: {
        useErrorBoundary: false,
        enabled: false, // Force trigger by refetch
      },
    }
  )
